module.exports = __webpack_public_path__ + "static/media/success_icon.b3c608d9.svg";